import { useMemo } from 'react';
import type { Category } from '@eshop/types/categories.types.ts';

interface StatusTag {
  key: string;
  label: string;
  color: string;
  isVisible: boolean;
}

interface UseCatalogueFiltersArgs {
  selectedCategory?: Category;
  totalProducts: number;
  isItemLoading: boolean;
  hasMore: boolean;
}

interface UseCatalogueFiltersResult {
  heroEyebrow: string;
  categoryTitle: string;
  heroDescription: string;
  statusTags: StatusTag[];
}

const HERO_EYEBROW = '';

export const useCatalogueFilters = ({
  selectedCategory,
  isItemLoading,
}: UseCatalogueFiltersArgs): UseCatalogueFiltersResult => {
  const categoryTitle = useMemo(
    () => selectedCategory?.name ?? 'Todos los productos',
    [selectedCategory],
  );

  // Show category description if available, otherwise empty
  const heroDescription = useMemo(
    () => selectedCategory?.description || '',
    [selectedCategory],
  );

  // Minimal status tags - only show loading state (system status feedback)
  const statusTags = useMemo<StatusTag[]>(
    () => [
      {
        key: 'loading',
        label: 'Actualizando catálogo',
        color: 'purple',
        isVisible: isItemLoading,
      },
    ],
    [isItemLoading],
  );

  return {
    heroEyebrow: HERO_EYEBROW,
    categoryTitle,
    heroDescription,
    statusTags,
  };
};

